module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
    var u = require('util/Util.js').default;
    var checked= u.isTrue( selected ) ? "checked" : "";

    ; __append("\r\n<div id=\"")
    ; __append(escapeFn( id ))
    ; __append("\" class=\"pf-control pf-editable pf-selectable radiobutton has-menu\" tabindex=\"")
    ; __append(escapeFn( tabIndex ))
    ; __append("\" draggable=\"true\"\r\n     style=\"left:")
    ; __append(escapeFn( left ))
    ; __append("px; top:")
    ; __append(escapeFn( top ))
    ; __append("px;\r\n             width: ")
    ; __append(escapeFn( u.extractNum(width)))
    ; __append("px; height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\r\n             z-index:")
    ; __append(escapeFn( zOrder ))
    ; __append(";\r\n                -webkit-border-radius: 0px;\r\n                -moz-border-radius: 0px;\r\n                border-radius: 0px;\r\n                border: 1px none #000000;\">\r\n\r\n    <div class=\"pf-control-core\" >\r\n\r\n        ")
    ;  
            let localizedText = u.getLocalizedText(id, 'text') || text;  
        
    ; __append("\r\n        <div class=\"checkbox\" name=\"")
    ; __append(escapeFn( name ))
    ; __append("\"\r\n             style = \"margin:0px;\r\n                     width: ")
    ; __append(escapeFn( u.extractNum(width)))
    ; __append("px;\r\n                     height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\r\n                     font-family: ")
    ; __append(escapeFn(u.resolveCompliantFontFamilyName(fontFamily)))
    ; __append(";\r\n                     font-size: ")
    ; __append(escapeFn(fontSize))
    ; __append("px;\r\n                     font-style: ")
    ; __append(escapeFn(textStyle))
    ; __append(";\r\n                     font-weight: ")
    ; __append(escapeFn(textWeight))
    ; __append(";\r\n                     color: ")
    ; __append(escapeFn(styleColorText))
    ; __append(";\r\n                     line-height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\r\n                     background-color: ")
    ; __append(escapeFn(backgroundColor))
    ; __append(";\" >\r\n           <label for=\"input-confidencial\" style=\"white-space:nowrap; padding-left: 0px; margin-top: -1px;\">\r\n                <input type=\"radio\" id=\"input-confidencial\" style=\"margin-top: -1px; vertical-align: middle; position: relative;\"\r\n                   value=\"")
    ; __append(escapeFn( value ))
    ; __append("\" ")
    ; __append(escapeFn( checked ))
    ; __append(" />\r\n               <span style=\"font-weight: ")
    ; __append(escapeFn(textWeight))
    ; __append("; padding-left:5px;\">")
    ; __append(escapeFn( localizedText ))
    ; __append("</span>\r\n           </label>\r\n        </div>\r\n\r\n    </div>\r\n\r\n    <div class=\"size-handle-top\"    style=\"width:  ")
    ; __append(escapeFn( u.extractNum(width)  ))
    ; __append("px;\"></div>\r\n    <div class=\"size-handle-left\"   style=\"height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\"></div>\r\n    <div class=\"size-handle-right\"  style=\"height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\"></div>\r\n    <div class=\"size-handle-bottom\" style=\"width:  ")
    ; __append(escapeFn( u.extractNum(width)  ))
    ; __append("px;\"></div>\r\n\r\n</div>\r\n\r\n\r\n")
  }
  return __output;

}